import { createContext } from 'react'

export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
  Auto = 'auto',
}

export enum ResolvedTheme {
  Light = 'light',
  Dark = 'dark',
}

export type ThemeModeContextType = {
  themeMode: ThemeMode
  resolvedTheme: ResolvedTheme
  setThemeMode: (mode: ThemeMode) => void
}

export const ThemeModeContext = createContext<ThemeModeContextType>({
  themeMode: ThemeMode.Light,
  resolvedTheme: ResolvedTheme.Light,
  setThemeMode: () => undefined,
})
